<script setup>
import { computed } from 'vue';
import { Link, usePage } from '@inertiajs/vue3';
import { Bars3Icon } from '@heroicons/vue/24/outline';
import PersoneoLogo from '@/Components/PersoneoLogo.vue';
import useLayout from '@/useLayout';
import PrimaryButton from './PrimaryButton.vue';
import SecondaryButton from './SecondaryButton.vue';

const props = defineProps({
    background: { type: String, default: 'none', validator: (value) => ['white-fade', 'white', 'none'].includes(value) },
});

const cssBackground = computed(() => {
    if (props.background === 'none') {
        return 'bg-transparent';
    } else if (props.background === 'white-fade') {
        return 'relative after:absolute after:left-0 after:right-0 after:top-full after:h-10 after:bg-gradient-to-b after:from-white after:from-10% after:to-transparent';
    } else {
        return 'bg-white';
    }
});

const { isLeftSidebarOpen } = useLayout();

const page = usePage();
const authUser = computed(() => page.props.auth.user);
</script>

<template>
    <nav :class="cssBackground" class="navbar px-4 py-4 w-full flex gap-x-3 items-center justify-between z-10">
        <Bars3Icon 
            v-if="authUser && !authUser.isDemoUser"
            @click="isLeftSidebarOpen = true" 
            class="w-10 h-10 transition-all duration-300 ease-in-out cursor-pointer"
            :class="[isLeftSidebarOpen ? 'opacity-0' : 'opacity-100']"
        />
        <Link :href="route('landingpage')">
            <PersoneoLogo />
        </Link>

        <slot></slot>

        <div class="flex gap-x-3">
            <template v-if="!authUser || authUser.isDemoUser">
                <Link :href="route('register')">
                    <PrimaryButton>Sign up</PrimaryButton>
                </Link>
                <Link :href="route('login')">
                    <SecondaryButton>Login</SecondaryButton>
                </Link>
            </template>

            <slot name="right-sidebar-trigger"></slot>
        </div>
    </nav>
</template>
